<mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{label ? label : 'Company Filter'}}</mat-label>
    <mat-select placeholder="Select Company" (selectionChange)="selectCompany($event.value)" [formControl]="company">
        <ng-container *ngIf="(UsersSvc.CheckAgentRoleAdmin$ | async)">
            <mat-option *ngFor="let comp of companyList$ | async | sortBy:'asc':'displayOrder'"
                [value]="comp.id" title="{{comp.name}} - {{comp.companyCode}}">
                {{comp.name}} - {{comp.companyCode}}
            </mat-option>
        </ng-container>
        <ng-container *ngIf="(cobrandingCompany$ | async).length>0">
            <mat-option *ngFor="let comp of cobrandingCompany$ | async" [value]="comp.id"
                title="{{comp.name}} - {{comp.companyCode}}">
                {{comp.name}} - {{comp.companyCode}}
            </mat-option>
            <mat-option *ngIf="LgvApiSvc.AgentSS$ | async as comp" [value]="comp.company.id"
                title="{{comp.company.name}} - {{comp.company.companyCode}}">
                {{comp.company.name}} - {{comp.company.companyCode}}
            </mat-option>
        </ng-container>

    </mat-select>
</mat-form-field>